import React, { useRef } from 'react';
import clsx from 'clsx';
import TravelersRoomButton from '../TravelersRoomButton/TravelersRoomButton';
import RoomsTooltip from '../Tooltip/RoomsTooltip';
import styles from './RoomSelector.scss';
import RoomsTooltipVariant from '../Tooltip/RoomsTooltipVariant';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';

const RoomsSelector = () => {
  const tooltipTriggerRef = useRef(null);
  const tooltipPopoverRef = useRef(null);
  const isVariant = useIsHomePageVariantHook();

  return (
    isVariant ? (
      <div>
        <div className={clsx('position-relative width-full flex height-auto')}>
          <TravelersRoomButton ref={tooltipTriggerRef} />
        </div>
        <div className="flex flex-justify-end">
          <RoomsTooltipVariant
            tooltipTriggerRef={tooltipTriggerRef}
            tooltipPopoverRef={tooltipPopoverRef}
          />
        </div>
      </div>
    ) : (
      <div className={clsx('position-relative width-full flex height-auto flex-justify-start', styles.roomsSelectorWrapper)}>
        <TravelersRoomButton ref={tooltipTriggerRef} />
        <RoomsTooltip
          tooltipTriggerRef={tooltipTriggerRef}
          tooltipPopoverRef={tooltipPopoverRef}
        />
      </div>
    )
  );
};

export default RoomsSelector;
